import { StateCreator } from 'zustand'

import { AppInfo, AppInfoState } from './types'

export const createAppInfoSlice: StateCreator<AppInfoState> = (set) => ({
  appInfo: null,
  setAppInfo: (info: AppInfo) => set({ appInfo: info }),
})
